module.exports = __webpack_public_path__ + "static/media/slider_card-payment.ded67dd6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/slider_card-payment.jpg
// module id = 833
// module chunks = 0